import { addToRecord, updateRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { FeedLoadFulfilledAction } from '../../domains/feedLoad/actions.types';
import type { ThreadMarkAsSeenFulfilledAction } from '../../domains/threadMarkAsGroupSeenOnServer/actions.types';

import type { SentMarkAsSeenTelemetryValues, ThreadMarkAsSeenCache } from './types';

const initialState: ThreadMarkAsSeenCache = {};

export type ThreadTelemetryActions = ThreadMarkAsSeenFulfilledAction | FeedLoadFulfilledAction;

const addOrUpdateThreadTelemetry = (
  state: ThreadMarkAsSeenCache,
  payload: ThreadMarkAsSeenFulfilledAction['payload']
) => {
  const threadToAdd = payload.threadsToMarkAsSeen[0];
  if (!threadToAdd) {
    return state;
  }

  const threadId = threadToAdd.threadId;
  const viewerHasSeenBefore = payload.viewerHasSeenBefore;

  if (!state[threadId]) {
    const threadToAddToRecord: SentMarkAsSeenTelemetryValues = {
      telemetryContext: threadToAdd.telemetryContext,
      shouldLogAgain: true,
    };

    return addToRecord(state, threadId, threadToAddToRecord);
  }

  return updateRecord(state, threadId, {
    telemetryContext: threadToAdd.telemetryContext,
    shouldLogAgain: viewerHasSeenBefore ? !viewerHasSeenBefore : true,
  });
};

const resetLogAgain = (state: ThreadMarkAsSeenCache) => {
  const threadIds = Object.keys(state);

  return threadIds.reduce(
    (newState, threadId) =>
      updateRecord(newState, threadId, {
        shouldLogAgain: true,
      }),
    state
  );
};

const reducer: Reducer<ThreadMarkAsSeenCache, ThreadTelemetryActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return resetLogAgain(state);
    case 'THREAD.MARK_AS_GROUP_SEEN_FULFILLED':
      return addOrUpdateThreadTelemetry(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
